/** Elapsed seconds from ISO created_at to reference time (default now). */
export function elapsedSeconds(createdAt, nowMs = Date.now()) {
  if (!createdAt) return 0;
  const start = new Date(createdAt).getTime();
  if (Number.isNaN(start)) return 0;
  return Math.max(0, Math.floor((nowMs - start) / 1000));
}

/** MM:SS for large KDS display (readable from ~1m). */
export function formatKdsTimer(totalSeconds) {
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

/**
 * Urgency bands for kitchen ticket ageing.
 * @param {number} totalSeconds
 * @param {number} alertMinutes — from restaurant settings (default 15)
 */
export function timerUrgency(totalSeconds, alertMinutes = 15) {
  const warnMinutes = Math.max(5, alertMinutes - 5);
  const mins = totalSeconds / 60;
  if (mins >= alertMinutes) return "critical";
  if (mins >= warnMinutes) return "warning";
  return "fresh";
}

export const URGENCY_THEME = {
  fresh: {
    label: "On time",
    timer: "text-slate-900",
    timerBg: "bg-slate-100",
    ring: "",
    cardTint: "",
    dot: "bg-emerald-500",
  },
  warning: {
    label: "Warning",
    timer: "text-amber-700",
    timerBg: "bg-amber-100",
    ring: "ring-2 ring-amber-400 ring-offset-1",
    cardTint: "bg-amber-50/40",
    dot: "bg-amber-500",
  },
  critical: {
    label: "Overdue",
    timer: "text-red-700",
    timerBg: "bg-red-100",
    ring: "ring-2 ring-red-500 ring-offset-1 animate-pulse",
    cardTint: "bg-red-50/50",
    dot: "bg-red-600",
  },
};
